import { render, staticRenderFns } from "./UnfurlDialog.vue?vue&type=template&id=31f0bab2&scoped=true"
import script from "./UnfurlDialog.vue?vue&type=script&lang=js"
export * from "./UnfurlDialog.vue?vue&type=script&lang=js"
import style0 from "./UnfurlDialog.vue?vue&type=style&index=0&id=31f0bab2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f0bab2",
  null
  
)

export default component.exports